import styled from "styled-components";
import { SidebarContainer } from "@8x8/oxygen-sidebar-menu";

export const PrintDisabledSidebarContainer = styled(SidebarContainer)`
  @media print {
    display: none !important;
  }
  ${({ isIframe }) =>
    isIframe &&
    `
    display: none !important;
  `}
`;
